<template>
    <div class="order_content">
        <div class="tabs_content">
            <ul>
                <li @click="orderjump">订货单</li>
                <li class="active">退货单</li>
            </ul>
        </div>
        <div class="order_box">
            <div class="order_search_content">
                <div class="order_search_list">
                    <Input v-model="pclikename" search enter-button="搜索" placeholder="订单号/商品名称" @on-search="searchClick" style="width: 212px;" />
                </div>
                <div class="order_search_list">
                    <Select v-model="status" clearable style="width: 148px;" placeholder="退货单状态" @on-change="searchClick">
                        <Option :value="0">全部</Option>
                        <Option :value="index" v-for="(item, index) in statusname" :key="index">{{item}}</Option>
                    </Select>
                </div>
                <div class="order_search_list">
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间" style="width: 148px;" @on-change="starChange"></DatePicker>
                    <span class="order_search_spacer">~</span>
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间" style="width: 148px;" @on-change="endChange"></DatePicker>
                </div>
            </div>
            <div class="order_table_content">
                <Table
                    border
                    ref="selection"
                    :loading="tloading"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
            <!-- 分页 -->
            <div class="page_content">
                <Page
                    :total="pagetotal"
                    :current="pagecurrent"
                    :page-size="pagesize"
                    :page-size-opts="pagesizeopts"
                    show-total
                    show-sizer
                    show-elevator
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
            </div>
        </div>
        <!-- 取消订单原因 -->
        <Cancelorder :cancelorderShow="cancelorderShow" :cancelorderInfo="cancelorderInfo" @cancelorderOk="cancelorderOk" @cancelorderCancel="cancelorderCancel"></Cancelorder>
        <!-- 确认发货 -->
        <DeliverGoods :delivergoodsShow="delivergoodsShow" @delivergoodsOk="delivergoodsOk" @delivergoodsCancel="delivergoodsCancel"></DeliverGoods>
    </div>
</template>

<script>
import api from '@/request/api.js'
import Cancelorder from '@/components/component/popup/cancelorder.vue'
import DeliverGoods from '@/components/component/popup/delivergoods.vue'
export default {
    props: ['searchsign', 'searchname'],
    components: {Cancelorder, DeliverGoods},
    data() {
        return {
            tloading: false, // 表格加载中
            cancelorderShow: false, // 取消订单弹窗是否显示
            cancelorderInfo: '', // 取消订单原因
            orderid: '', // 当前退款id
            delivergoodsShow: false, // 确认发货弹窗是否显示
            thead: [ // 表格头部
                {
                    width: 340,
                    title: '单号',
                    key: 'ordernumber',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_number'
                                    },
                                    [
                                        h('span', params.row.rebackdno),
                                        h('span', params.row.addtime),
                                    ]
                                )
                    }
                },
                {
                    title: '退货金额 (元)',
                    key: 'rebackallcost'
                },
                {
                    title: '订单状态',
                    key: 'statusname',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            color: params.row.status != 4 && params.row.status != 5 && params.row.status != 6 ? '#FF8000' : ''
                                        }
                                    },
                                    params.row.statusname
                                )
                    }
                },
                {
                    title: '操作',
                    key: 'operation',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_operation'
                                    },
                                    [
                                        h('span',
                                            {
                                                on: {
                                                    click: () => {
                                                        this.detailsClick(params.row.id)
                                                    }
                                                },
                                            },
                                            '详情'
                                        ),
                                        h('span',
                                            {
                                                style: {
                                                    display: params.row.status == 0 ? 'inline' : 'none'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.cancelClick(params.row.id)
                                                    }
                                                },
                                            },
                                            '取消退货'
                                        ),
                                        h('span',
                                            {
                                                style: {
                                                    display: params.row.status == 1 ? 'inline' : 'none'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.confirmClick(params.row.id)
                                                    }
                                                },
                                            },
                                            '确认发货'
                                        )
                                    ]
                                )
                    }
                }
            ],
            goodslist: [], // 表格列表
            pclikename: '', // 订单号/商品名称
            status: '', // 付款状态
            stardatetiem: '', // 开始时间
            enddatetiem: '', // 结束时间
            statusname: {}, // 退货单状态
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取订单信息
            if (!this.$store.state.openmall) {
                this.tloading = true
                this.http.post(api.returnlist,
                    {
                        likename: this.pclikename,
                        status: this.status,
                        starttime: this.stardatetiem,
                        endtime: this.enddatetiem,
                        page: this.pagecurrent,
                        pagesize: this.pagesize,
                    }
                )
                .then(response => {
                    console.log(response)
                    this.goodslist = response.data.msg.rebackorderlist
                    this.statusname = response.data.msg.statusname
                    // 获取商品分页
                    this.pagetotal = response.data.msg.order_pagecontent.num
                    this.tloading = false
                })
                .catch(error => {
                    this.$Message.warning(error);
                })
            }
        },
        orderjump () { // 跳转链接
            this.$router.push({
                path: '/Order'
            })
        },
        detailsClick (id) { // 订单详情
            this.$router.push({
                name: '退货单订单详情',
                params: {
                    id: id
                }
            })
        },
        searchClick () { // 点击搜索按钮
            this.pagecurrent = 1
            this.getInfo()
        },
        starChange (e) { // 搜索订单开始时间
            if (e > this.enddatetiem && this.enddatetiem != '') {
                this.$Message.warning('开始时间不能大于结束时间')
            } else if (this.enddatetiem != '') {
                this.stardatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.stardatetiem = e
            }
        },
        endChange (e) { // 搜索订单结束时间
            if (e < this.stardatetiem && this.stardatetiem != '') {
                this.$Message.warning('结束时间不能小于开始时间')
                this.enddatetiem = ''
            } else if (this.stardatetiem != '') {
                this.enddatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.enddatetiem = e
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
        searchinfo () { // 右上角搜索
            if (this.searchsign == 'returnorder') {
                this.pclikename = this.searchname
                this.getInfo()
            } else {
                this.getInfo()
            }
        },
        cancelClick (id) { // 取消退货弹窗
            this.orderid = id
            this.cancelorderShow = true
        },
        cancelorderOk (e) { // 填写取消订单原因
            this.cancelorderShow = false
            this.cancelorderInfo = e
            this.ordercancel()
        },
        cancelorderCancel () { // 关闭备注弹窗
            this.cancelorderShow = false
        },
        ordercancel () { // 取消退货
            this.http.post(api.returncancel,
                {
                    rebackid: this.orderid,
                    closereason: this.cancelorderInfo
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        confirmClick (id) { // 确认发货弹窗
            this.delivergoodsShow = true
            this.orderid = id
        },
        delivergoodsOk (e) { // 确认发货
            this.http.post(api.delivergoods,
                {
                    rebackid: this.orderid,
                    sendtime: e.datetiem,
                    returnfirm: e.logistics,
                    returnodd: e.ordernum,
                }
            )
            .then(response => {
                this.$Message.success(response.data.msg)
                this.getInfo()
            })
            .catch(error => {
                this.$Message.warning(error)
            })
        },
        delivergoodsCancel () { // 关闭确认发货弹窗
            this.delivergoodsShow = false
        }
    },
    created () {
        if (this.$route.params.statetype != undefined) this.status = this.$route.params.statetype
        this.searchinfo()
    },
    watch: {
        searchname () {
            this.searchinfo()
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/order/orderreturn.vue